import axios from '../utilities/axiosConfig';
import { toast } from 'react-toastify';

const useData = () => {
  const fetchAllUsers = async () => {
    try {
      const response = await axios.post('/user/fetch-all-users', {
        withCredentials: true,
        credentials: 'include',
      });

      console.log('Response:', response.data.userList);

      return response.data.userList;
    } catch (error) {
      console.log('Error occurred:', error);
      return null;
    }
  };

  const getAllPosts = async () => {
    try {
      const response = await axios.get('/post/getAllPosts', {
        withCredentials: true,
        credentials: 'include',
      });

      console.log('Response 889999:', response.data);

      return response.data;
    } catch (error) {
      console.log('Error occurred:', error);
      return null;
    }
  };

  const createPost = async (postData) => {
    try {
      const response = await axios.post('/post/createPost', postData, {
        withCredentials: true,
        credentials: 'include',
      });

      console.log('Response 889999:', response.data);

      return response.data;
    } catch (error) {
      console.log('Error occurred:', error);
      return null;
    }
  };

  const updatePost = async (postId, newData) => {
    try {
      const response = await axios.put(`/post/updatePost/${postId}`, newData, {
        withCredentials: true,
        credentials: 'include',
      });

      console.log('Response:', response.data);

      return response.data;
    } catch (error) {
      console.error('Error occurred:', error);
      throw error; // Re-throw the error to propagate it to the caller
    }
  };

  const deletePost = async (postId) => {
    try {
      // const response = await axios.delete("/post/deletePost", postData, {
      //   withCredentials: true,
      //   credentials: "include",
      // });

      const response = await axios.delete(`/post/deletePost/${postId}`, {
        withCredentials: true,
        credentials: 'include',
      });

      console.log('Response 889999:', response.data);

      return response.data;
    } catch (error) {
      console.log('Error occurred:', error);
      return null;
    }
  };

  const sampleFormSubmission = async (formData) => {
    console.log('FPRM DATA:', formData);
    try {
      const response = await axios.post(`/user/upload-form-data`, formData, {
        withCredentials: true,
        credentials: 'include',
        headers: {
          'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
        },
      });

      console.log('Response:', response.data);

      if (response.data.success) {
        toast.success(response.data.message, {
          autoClose: 2000,
          position: 'top-center',
        });
      }
    } catch (error) {
      console.error('Error occurred:', error);
      throw error; // Re-throw the error to propagate it to the caller
    }
  };

  const fetchAllRolesAndPermissions = async () => {
    // Fetch all roles and permissions
    try {
      const response = await axios.post(`/user/upload-form-data`, formData, {
        withCredentials: true,
        credentials: 'include',
        headers: {
          'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
        },
      });

      console.log('Response:', response.data);

      if (response.data.success) {
        toast.success(response.data.message, {
          autoClose: 2000,
          position: 'top-center',
        });
      }
    } catch (error) {
      console.error('Error occurred:', error);
      throw error; // Re-throw the error to propagate it to the caller
    }
  };

  const getUsersByQuery = async (query) => {
    try {
      console.log('8080:', query);
      const response = await axios.post('/user/get-users-by-query', query, {
        withCredentials: true,
        credentials: 'include',
      });

      console.log('8080:', response.data);

      return response.data;
    } catch (error) {
      console.log('Error occurred:', error);
      return null;
    }
  };

  const getAllUsers = async () => {
    try {
      const response = await axios.get('/user/get-all-users', {
        withCredentials: true,
        credentials: 'include',
      });

      return response.data;
    } catch (error) {
      console.error('Error occurred:', error);
      throw error; // Re-throw the error to propagate it to the caller
    }
  };

  const getAllRoles = async () => {
    try {
      const response = await axios.get('/user/get-all-roles', {
        withCredentials: true,
        credentials: 'include',
      });

      console.log('Response:', response.data);

      return response.data;
    } catch (error) {
      console.error('Error occurred:', error);
      throw error; // Re-throw the error to propagate it to the caller
    }
  };
  const getAllPermissions = async () => {
    try {
      const response = await axios.get('/user/get-all-permissions', {
        withCredentials: true,
        credentials: 'include',
      });

      console.log('Response:', response.data);

      return response.data;
    } catch (error) {
      console.error('Error occurred:', error);
      throw error; // Re-throw the error to propagate it to the caller
    }
  };

  const getAllLocations = async () => {
    try {
      const response = await axios.get('/location/getAllLocations', {
        withCredentials: true,
        credentials: 'include',
      });
      return response.data.data;
    } catch (error) {
      console.error('Error occurred:', error);
      throw error; // Re-throw the error to propagate it to the caller
    }
  };

  const getLocation = async (LocationId) => {
    try {
      const response = await axios.post(`/location/getlocation/${LocationId}`, {
        withCredentials: true,
        credentials: 'include',
      });
      return response.data;
    } catch (error) {
      console.error('Error occurred:', error);
      throw error; // Re-throw the error to propagate it to the caller
    }
  };

  const addNewLocation = async (formValues) => {
    const response = await axios.post(
      '/location/createLocation',
      { ...formValues },
      { withCredentials: true, credentials: 'include' },
    );

    if (response.status == 200) {
      return response.data.success;
    }
    return null;
  };

  const updateLocation = async (locationId, formValues) => {
    const response = await axios.put(
      `/location/updateLocation/${locationId}`,
      { ...formValues },
      { withCredentials: true, credentials: 'include' },
    );

    if (response.status == 200) {
      return response.data.success;
    }
    return null;
  };

  const deactivateLocation = async (locationId) => {
    const response = await axios.put(`/location/deactivateLocation/${locationId}`, {
      withCredentials: true,
      credentials: 'include',
    });

    if (response.status == 200) {
      return response.data.success;
    }
    return null;
  };

  const restoreLocation = async (locationId) => {
    const response = await axios.put(`/location/restoreLocation/${locationId}`, {
      withCredentials: true,
      credentials: 'include',
    });

    if (response.status == 200) {
      return response.data.success;
    }
    return null;
  };
  /*eslint-disable */
  const searchDockets = async (filters) => {
    console.log('Filters:', filters);
    try {
      const response = await axios.post('/docket/fetch-filtered-dockets', filters, {
        withCredentials: true,
        credentials: 'include',
      });
      return response;
    } catch (error) {
      console.log('Error in searching dockets: ', error);
    }
  };

  const getAllAgencies = async () => {
    try {
      const response = await axios.get('/admin/getAgency', {
        withCredentials: true,
        credentials: 'include',
      });
      return response.data;
    } catch (error) {
      console.error('Error occurred:', error);
      throw error; // Re-throw the error to propagate it to the caller
    }
  };

  const getAllStates = async () => {
    try {
      const response = await axios.get('/admin/getAllStates', {
        withCredentials: true,
        credentials: 'include',
      });

      return response.data.data ? response.data.data : [];
    } catch (error) {
      console.error('Error occurred:', error);
      throw error; // Re-throw the error to propagate it to the caller
    }
  };
  
  const getAllRoleTypes = async () => {
    try {
      const response = await axios.post('/user/get-all-role-types');

      return response.data ? response.data : [];
    } catch (error) {
      console.error('Error occurred:', error);
      throw error; // Re-throw the error to propagate it to the caller
    }
  };

  return {
    fetchAllUsers,
    getAllPosts,
    createPost,
    updatePost,
    deletePost,
    sampleFormSubmission,
    getAllUsers,
    getAllRoles,
    getAllPermissions,
    getAllLocations,
    addNewLocation,
    getLocation,
    updateLocation,
    deactivateLocation,
    restoreLocation,
    searchDockets,
    getAllAgencies,
    getAllStates,
    getUsersByQuery,
    getAllRoleTypes,
  };
};

export default useData;
